import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

function OrgSettings({ orgId, onBack }) {
  const [classroomPin, setClassroomPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [currentPin, setCurrentPin] = useState('');
  const [orgName, setOrgName] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchOrgDetails();
  }, []);

  const fetchOrgDetails = async () => {
    const { data, error } = await supabase
      .from('organizations')
      .select('name, classroom_pin')
      .eq('id', orgId)
      .single();

    if (!error && data) {
      setOrgName(data.name);
      setCurrentPin(data.classroom_pin || '');
    }
  };

  if (!orgId) {
    return (
      <div>
        <div className="top-bar">
          <button className="btn btn-gray" onClick={onBack}>← Back</button>
        </div>
        <div className="header">
          <h2>⚙️ Settings</h2>
        </div>
        <div className="error-message">
          Please select an organization first before accessing settings.
        </div>
      </div>
    );
  }

  const handleSavePin = async () => {
    setError('');
    setMessage('');

    if (!classroomPin || classroomPin.length !== 4) {
      setError('Please enter a 4 digit PIN.');
      return;
    }

    if (classroomPin !== confirmPin) {
      setError('PINs do not match. Please try again.');
      return;
    }

    setLoading(true);

    const { error } = await supabase
      .from('organizations')
      .update({ classroom_pin: classroomPin })
      .eq('id', orgId);

    if (error) {
      setError('Error saving PIN: ' + error.message);
      setLoading(false);
      return;
    }

    setMessage('✅ Classroom PIN updated successfully!');
    setCurrentPin(classroomPin);
    setClassroomPin('');
    setConfirmPin('');
    setLoading(false);
  };

  return (
    <div>
      <div className="top-bar">
        <button className="btn btn-gray" onClick={onBack}>← Back</button>
      </div>

      <div className="header">
        <h2>⚙️ Organization Settings</h2>
        <p>{orgName}</p>
      </div>

      <div style={sectionStyle}>
        <p className="section-title">📺 Classroom View PIN</p>
        <p style={{ color: '#888', fontSize: '14px', marginBottom: '16px' }}>
          This PIN is used to access the classroom view on iPads or TVs. Share it only with trusted staff members.
        </p>

        {currentPin ? (
          <div style={currentPinStyle}>
            <p style={{ margin: 0, fontSize: '14px', color: '#2e7d52', fontWeight: '600' }}>
              ✅ Classroom PIN is set
            </p>
          </div>
        ) : (
          <div style={noPinStyle}>
            <p style={{ margin: 0, fontSize: '14px', color: '#856404', fontWeight: '600' }}>
              ⚠️ No classroom PIN set yet
            </p>
          </div>
        )}

        <div style={{ marginTop: '20px' }}>
          <input
            className="input"
            placeholder="New 4 digit PIN"
            value={classroomPin}
            onChange={(e) => setClassroomPin(e.target.value.slice(0, 4))}
            type="password"
            maxLength={4}
          />
          <input
            className="input"
            placeholder="Confirm PIN"
            value={confirmPin}
            onChange={(e) => setConfirmPin(e.target.value.slice(0, 4))}
            type="password"
            maxLength={4}
          />

          <button className="btn btn-primary" onClick={handleSavePin} disabled={loading}>
            {loading ? 'Saving...' : 'Save Classroom PIN'}
          </button>
        </div>

        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}
      </div>

      <div style={sectionStyle}>
        <p className="section-title">🔗 Classroom View Link</p>
        <p style={{ color: '#888', fontSize: '14px', marginBottom: '16px' }}>
          Share this link with classroom staff to access the classroom view on any device.
        </p>
        <div style={linkBoxStyle}>
          <p style={{ fontSize: '13px', color: '#1a56db', wordBreak: 'break-all', margin: 0 }}>
            {`https://saferoster.app/app?classroom=true&org=${orgId}`}
          </p>
        </div>
        <button
          className="btn btn-blue btn-small"
          style={{ marginTop: '12px', width: '100%' }}
          onClick={() => {
            navigator.clipboard.writeText(`https://saferoster.app/app?classroom=true&org=${orgId}`);
            alert('Link copied to clipboard!');
          }}
        >
          📋 Copy Link
        </button>
      </div>
    </div>
  );
}

const sectionStyle = {
  background: '#f8faff',
  border: '2px solid #e8f0fe',
  borderRadius: '16px',
  padding: '24px',
  marginBottom: '16px',
};

const currentPinStyle = {
  background: '#e8f8f0',
  border: '1px solid #b7e4c7',
  borderRadius: '10px',
  padding: '12px 16px',
};

const noPinStyle = {
  background: '#fff3cd',
  border: '1px solid #ffc107',
  borderRadius: '10px',
  padding: '12px 16px',
};

const linkBoxStyle = {
  background: '#e8f0fe',
  border: '1px solid #c7d9fb',
  borderRadius: '10px',
  padding: '12px 16px',
};

export default OrgSettings;